import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogProps, DialogTitle, IconButton, Typography } from '@mui/material';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { LOGIN_PATH } from 'models/Paths';
import Icon from '../Icon/Icon';

interface IIconModalProps extends DialogProps {
    open: boolean;
    icon?: React.ReactNode;
    title?: string;
    text?: React.ReactNode;
    imageComponent?: React.ReactNode;
    button?: {
        title: string;
        disabled?: boolean;
        onClick(): void;
    };
    onClose(): void;
}


export const IconModal = (props: IIconModalProps) => {
    const { open, onClose, title, text, icon, button, imageComponent, children } = props;
    const history = useHistory();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{ style: { overflow: 'initial' }, className: 'spacing double padding all text-align-center' }}
            maxWidth="xs"
            fullWidth
        >
            <IconButton style={{ position: 'absolute', top: 12, right: 12 }} size="small" onClick={onClose}>
                <Icon icon={faTimes} fontSize="small" />
            </IconButton>

            {title && (
                <DialogTitle>
                    <Typography variant="h6" style={{
                        margin: '1em 0 0 0'
                    }}>{title}</Typography>
                </DialogTitle>
            )}
            <DialogContent>
                {text && <DialogContentText>{text}</DialogContentText>}
                {children}
            </DialogContent>
            <Box
            sx={{
                position: 'absolute',
                top: '-2%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
            >
            {imageComponent
                ? imageComponent
                : typeof icon === 'string'
                ? <img src={icon} alt="modal-icon" style={{ maxWidth: 64, maxHeight: 64 }} />
                : icon}
            </Box>

            {button && (
                <Button variant="outlined" fullWidth={false} onClick={button.onClick} disabled={button.disabled}>
                    {button.title}
                </Button>
            )}
        </Dialog>
    );
};

export default IconModal;

